<template>
  <a-menu
    mode="inline"
    theme="light"
    v-model="selectedKeys"
    :style="{ height: '100%', borderRight: 0 }"
    @click="onSelect"
  >
  <template v-for="item,key in siderMenu">
    <a-menu-item :key="key">
      {{item.name}}
    </a-menu-item>
  </template>
  </a-menu>
</template>

<script>
export default {
  components: {},
  props: {
  },
  data() {
    return {
      selectedKeys: ['device'],
      siderMenu: {
        device: {
          name: '设备管理',
          url: '/device'
        },
        order: {
          name: '订单管理',
          url: '/order'
        },
        refund: {
          name: '退款查询',
          url: '/refund'
        },
        data: {
          name: '数据统计',
          url: '/data'
        },
        // images: {
        //   name: '图片查询',
        //   url: '/images'
        // }
      },
    }
  },
  watch: {
    $route() {
      this.selectedKeys = [this.currentMenu]
    }
  },
  computed: {
    activeMenu() {
      const route = this.$route
      const { path } = route
      return path
    },
    currentMenu() {
      const route = this.$route
      const { currentMenu } = route.meta
      return currentMenu
    }
  },
  created() {},
  mounted() {
    this.selectedKeys = [this.currentMenu]
  },
  methods: {
    onSelect({ item, key }) {
      this.$router.push(this.siderMenu[key].url)
    },
  },
  destroyed() {},
};
</script>

<style lang="less" scoped>
</style>
